import {
  createCourse,
  updateCourse,
  deleteCourse,
  createCategory,
  updateCategory,
  deleteCategory,
} from './course';

import {
  createLesson,
  updateLesson,
  deleteLesson,
  submitLesson,
  submitLessonFacilitator,
  updateSubmitLesson,
  updateCourseLessonsProgress,
  incrementQuizQuestionAttempts,
  getCourseLessonsProgress
} from './lesson';

import {
  createEvent,
  updateEvent,
  deleteEvent
} from './event';

import {
  createResource,
  updateResource,
  deleteResource,
  deleteResourceCategory,
} from './resource';

import {
  updateOverallRanks,
  createBadge,
  updateBadge
} from "./achievements"

import { learnerAnnualQuestionnaireUpdate } from './questionnaire';

export default {
  createCourse,
  updateCourse,
  deleteCourse,
  createCategory,
  updateCategory,
  deleteCategory,
  createLesson,
  updateLesson,
  deleteLesson,
  submitLesson,
  submitLessonFacilitator,
  updateSubmitLesson,
  updateCourseLessonsProgress,
  getCourseLessonsProgress,
  incrementQuizQuestionAttempts,
  createResource,
  updateResource,
  deleteResource,
  deleteResourceCategory,
  deleteEvent,
  updateEvent,
  createEvent,
  updateOverallRanks,
  createBadge,
  updateBadge,
  learnerAnnualQuestionnaireUpdate
};
